import PmcBridge from 'shared/services/pmc-bridge'

export default class HeaderTopbar {
	private headerTopbar: HTMLElement | null
	private magazineCardLink: HTMLAnchorElement | null | undefined
	private subscribeCta: HTMLAnchorElement | null | undefined
	private PMCBrige: PmcBridge
	private isUserSubscribed: Awaited<ReturnType<typeof PmcBridge.prototype.hasSubscription>>

	constructor() {
		this.headerTopbar = document.querySelector('.headerTopbar')
		this.magazineCardLink = this.headerTopbar?.querySelector('.headerTopbar-cardLink')
		this.subscribeCta = this.headerTopbar?.querySelector(
			'.headerTopbar-linksPrimarySubscribeCta'
		)
		this.PMCBrige = new PmcBridge()
		this.isUserSubscribed = false

		this.updateMagazineCard = this.updateMagazineCard.bind(this)
		this.removeSubscribeCta = this.removeSubscribeCta.bind(this)
	}

	async init() {
		this.isUserSubscribed = await this.PMCBrige.hasSubscription()

		if (this.isUserSubscribed) {
			this.updateMagazineCard()
			this.removeSubscribeCta()
		}
	}

	/**
	 * Update the magazine card link href to the subscribed href
	 */
	updateMagazineCard() {
		const subscribedHref = this.magazineCardLink?.getAttribute('data-subscribed-href')

		if (subscribedHref && this.magazineCardLink) {
			this.magazineCardLink.setAttribute('href', subscribedHref)
		}
	}

	/**
	 * Remove the subscribe CTA if the user has subscribed
	 */
	removeSubscribeCta() {
		this.subscribeCta?.remove()
	}
}
